<template>
  <div>
    <Table  ref="selection" :columns="columns12" :data="MaterialinfoLists" max-height="600">
        <template slot-scope="{ index }"  slot="material_icon">
            <Avatar size="large" :src="MaterialinfoLists[index].material_icon" style="background-color: #87d068"/>
        </template>
        <template slot-scope="{ index }" slot="action">
            <a href="#" @click.prevent="EditHandleClick(index)">
            编辑
          </a>
            <Divider type="vertical" />
            <Poptip
            placement="left"
            confirm
            title="你确定要删除这条物料信息吗?"
            @on-ok="remove(index)"
            >
             <Button type="error" ghost size="small">删除</Button>
            </Poptip>
        </template>
    </Table>
  </div>
</template>

<script>
import bus from './Bus.js'
export default {
  name: 'MaterialTable',
  props: {
    MaterialinfoLists: Array
  },
  data () {
    return {
      columns12: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '物料编码',
          key: 'materiel_code'
        },
        {
          title: '物料名称',
          key: 'materiel_name'
        },
        {
          title: '大类',
          key: 'material_category'
        },
        {
          title: '属性汇总',
          key: 'material_subclass'
        },
        {
          title: '状态',
          key: 'material_state'
        },
        {
          title: '类型',
          key: 'type'
        },
        {
          title: '图标',
          slot: 'material_icon',
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ]
    }
  },
  mounted: function () {
    bus.$on('QueryHandleClick', (formItem) => {
      this.$emit('QueryHandleClick', formItem)
    })
  },
  methods: {
    // show (index) {
    //   this.$Modal.info({
    //     title: 'User Info',
    //     content: `Name：${this.data6[index].name}<br>Age：${this.data6[index].age}<br>Address：${this.data6[index].address}`
    //   })
    // },
    // 点击编辑事件回调
    EditHandleClick (index) {
      this.$emit('EditHandleClick', index)
    },
    // 点击删除按钮回调
    remove (index) {
      // this.data6.splice(index, 1)
      this.$emit('DeleteHandleClick', index)
    }
  }
}
</script>
